module.exports = ".header-menu-dropdown {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.header-menu-link {\r\n    cursor: pointer;\r\n     margin-right: 5px;\r\n}\r\n\r\n.header-menu-item {\r\n    padding: 0 !important;\r\n}\r\n\r\n.header-menu-item a {\r\n    margin-right: 5px;\r\n}\r\n\r\n.header-dropdown-content {\r\n    z-index: 1001; \r\n    display: block;\r\n    top: 22.0005px;\r\n}\r\n\r\n.header-dropdown-content-hide {\r\n    display:none;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header-menu-item/header-menu-item.component.css
// module id = ./src/app/shared/header-menu-item/header-menu-item.component.css
// module chunks = main